<template>
	<div class="profile-stat-tiles">

		<ProfileStatsTile>
			<template v-slot:icon>
				<notes-icon> </notes-icon>
			</template>
			<template v-slot:name>
				{{ userStore.userMetrics.offers_completed }}
			</template>
			<template v-slot:description> Offers Completed </template>
		</ProfileStatsTile>


		<ProfileStatsTile>
			<template v-slot:icon>
				<coin-stack-icon></coin-stack-icon>
			</template>
			<template v-slot:name>
				{{ userStore.user.coins_total }}
			</template>
			<template v-slot:description>Total Coins Earned</template>
		</ProfileStatsTile>


		<ProfileStatsTile>
			<template v-slot:icon>
				<users-referred-icon></users-referred-icon>
			</template>
			<template v-slot:name>
				{{ userStore.user.referrals_count }}
			</template>
			<template v-slot:description>Users Referred</template>
		</ProfileStatsTile>


		<ProfileStatsTile>
			<template v-slot:icon>
				<coin-stack-icon></coin-stack-icon>
			</template>
			<template v-slot:name>
				{{ Math.floor(userStore.userMetrics.coins_earned_30_days) }}
			</template>
			<template v-slot:description>Last 30 days</template>
		</ProfileStatsTile>

	</div>
</template>



<script setup>
import NotesIcon from "@/icons/Notes.vue";
import { useUserStore } from "@/store/UserStore";
import CoinStackIcon from "@/icons/CoinStack.vue";
import UsersReferredIcon from "@/icons/UsersReferred.vue";
import ProfileStatsTile from "@/components/Profile/Profile-Stats-Tile.vue";

const userStore = useUserStore();

</script>